import React from 'react'

const Error = () => {
  return (
    <div>Error 401</div>
  )
}

export default Error